import React from 'react';
import Button from '../../shared/components/Form/Button';
import Avatar from '../../shared/components/UIElements/Avatar';
import './DatasetInfo.css';

const DatasetInfo = props => {

     return (
         <div className="datasetInfo">
             
          <h1>{props.title}</h1>
          <div className="dataset-description__image">
            <Avatar image={props.image} alt={props.title} />
          </div>
          <div className="dataset-description__info">
            <p><i>{props.description}</i> </p>
            <div className="dataset_title"><b>SPARQL Endpoint:</b> <a href={props.url} target="new">{props.url}</a></div> 
              <div className="dataset_active-div"><span
                    title={props.active ? "Endpoint Active" : "Endopint Inactive"} 
                    className={props.active ? "dataset-active-static" : "dataset-inactive"}>
                </span></div>
           
            <div className="dataset_ontologies"><b>Spatial Ontologies:</b>  </div>
            <div className="dataset_ontologies_list"><ul>
            {props.ontologies.map(ontology => (
              <li key={ontology.uri}>{ontology.ontology}&nbsp;(<a href={ontology.uri} target="new">{ontology.uri}</a>) </li>
            ))}
            </ul></div>
            
           <div className="dataset_stats">
            <p><b>Entities:</b> {props.numOfEntities} </p>
            <p><b>Classes:</b> {props.numOfClasses} </p>
            <p><b>Recommendations:</b> {props.numOfRecommendations} </p>
            </div>
          </div>
          <div className="class_dbuttons">
            <Button href={props.void} target="new" disabled={props.void===''} >Download VOID</Button>
            <Button href={`${process.env.REACT_APP_BACKEND_API_URL}/download/geovoid/${props.id}`} target="new">Export GeoVOID</Button>
            <Button href={`${process.env.REACT_APP_BACKEND_API_URL}/download/datasetrecommendations/${props.id}`} target="new">Export Recommendations</Button>
         </div>
         </div>
     );
};

export default DatasetInfo;
